(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-product-v1"] && !Shopify.designMode) return;
  try {
    
/*
document.addEventListener("DOMContentLoaded", function() {
  const tabLinks = document.querySelectorAll('.azirspares-tabs .tab-link a');

  tabLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();

      // dezactiveaza toate tab-urile
      document.querySelectorAll('.azirspares-tabs .tab-link li').forEach(li => li.classList.remove('active'));
      document.querySelectorAll('.azirspares-tabs .tab-panel').forEach(panel => panel.classList.remove('active'));

      // activeaza tab-ul curent
      this.parentElement.classList.add('active');

      const panel = document.querySelector(this.getAttribute('href'));
      if (panel) {
        panel.classList.add('active');
      }
    });
  });
});
*/

  } catch(e) { console.error(e); }
})();
})();
